import { css } from '@emotion/react';

export default ({ theme }) => css`
  .MuiDialog-paper {
    //max-height: 817px;
    //height: 80%;
  }
`;
